import api from "../config/api";

export const fetchBills = async (userId) => {
  if (!userId) {
    throw new Error("[FETCH_BILLS] User ID missing.");
  }

  const { data } = await api.get(`/platform/bills/${userId}`);

  return data;
};

export const fetchBill = async ({ userId, billId }) => {
  if (!userId) {
    throw new Error("[FETCH_BILL] User ID missing.");
  }

  if (!billId) {
    throw new Error("[FETCH_BILL] Bill ID missing.");
  }

  const { data } = await api.get(`/platform/bills/${userId}/${billId}`);

  return data;
};

export const createBill = async ({ userId, payload }) => {
  if (!userId) {
    throw new Error("[CREATE_BILL] User ID missing.");
  }

  const { data } = await api.post(`/platform/bills/${userId}/create`, payload);

  return data;
};

export const processImageBill = async (file) => {
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const base64Content = await toBase64(file);
  const base64Image = base64Content.split(",")[1];

  const fileType = file.type === "application/pdf" ? "pdf" : "image";

  const payload = {
    file_type: fileType,
    content: base64Image,
  };

  try {
    const { data } = await api.post(`/platform/bills/process_image`, payload);

    return data;
  } catch (error) {
    console.error("Error processing file:", error);
    throw error;
  }
};
